export const cartActionTypes = {

    ADD_TO_CART: 'ADD_TO_CART',
    REMOVE_FROM_CART: 'REMOVE_FROM_CART',
    REDUCE_QUANTITY: 'REDUCE_QUANTITY',
    INCREASE_QUANTITY: 'INCREASE_QUANTITY'
};

